'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollSnoop = require('./scroll-snoop');

var _scrollSnoop2 = _interopRequireDefault(_scrollSnoop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lazyLoad = function lazyLoad() {
  // lazy load images
  var active = false;

  var lazyLoad = function lazyLoad() {
    var lazyImages = [].slice.call(document.querySelectorAll('[data-lazy-background]'));

    if (lazyImages.length) {
      if (active === false) {
        active = true;

        setTimeout(function () {
          lazyImages.forEach(function (lazyImage, index) {
            if ((0, _scrollSnoop2.default)(lazyImage)) {
              var lazyBackground = lazyImage.dataset.lazyBackground;

              var url = 'url(\'' + lazyBackground + '\')';
              lazyImage.style.backgroundImage = url;
              lazyImage.removeAttribute('data-lazy-background');

              lazyImages = lazyImages.filter(function (image) {
                return image !== lazyImage;
              });
            }
          });
          active = false;
        }, 200);
      }
    }
  };

  document.addEventListener('scroll', lazyLoad);
  document.addEventListener('lazy:reload', lazyLoad);
  window.addEventListener('resize', lazyLoad);
  window.addEventListener('orientationchange', lazyLoad);
  lazyLoad();
};

exports.default = lazyLoad;